import { Component, OnDestroy } from '@angular/core';
import { IconService } from './core/services/icon.service';
import { AuthService } from '@rezolved/auth';
import { Router } from '@angular/router';
import { MxpTranslationService } from './core/services/mxp-translation.service';
import { Store } from '@ngrx/store';
import { IAppState } from './core/store/app.interface';
import { EMPTY, Subject } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import { NavbarToolbarContentService } from '@rezolved/ui';
import { MerchantService } from './core/services/mxp-merchant.service';
import { MerchantStatusEnum, MerchantTypeEnum } from '@rezolved/mxp-proto';
import { MatDialog } from '@angular/material/dialog';
import { EnrollmentSignatureDialogComponent } from './components/merchant-enrollment/enrollment-signature-dialog/enrollment-signature-dialog.component';

@Component({
  selector: 'mxp-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [AuthService],
})
export class AppComponent implements OnDestroy {

  private readonly destroy$: Subject<boolean> = new Subject<boolean>();
  title = 'mx-payment';
  shouldDisplayMainMenuOnProd = false;
  MerchantTypeEnum = MerchantTypeEnum

  constructor(
    private iconService: IconService,
    public authService: AuthService,
    public merchantService: MerchantService,
    public router: Router,
    private readonly mxpTranslationService: MxpTranslationService,
    private navbarToolbarContentService: NavbarToolbarContentService,
    private store: Store<IAppState>,
    private dialog: MatDialog)
  {
    this.shouldDisplayMainMenuOnProd = !window.location.href.includes('https://mxp.mx.rezolve.com/');
    this.iconService.registerIcons();
    this.mxpTranslationService.loadTranslation();
    this.merchantService.refreshMerchant();
    this.initNavbarToolbarContent();
  }

  private initNavbarToolbarContent() {
    this.store
      .select((state) => state.AppState)
      .pipe(takeUntil(this.destroy$))
      .subscribe((appState) => {
        if (appState?.currentStep) {
          setTimeout(() => {
            this.navbarToolbarContentService.setMobileNavigationTitle(
              this.mxpTranslationService.getTranslation(appState.currentStep),
            );
          });
        }
        this.navbarToolbarContentService.setLoading(appState?.isLoading ?? false);
      });

    this.authService.user$.pipe(takeUntil(this.destroy$)).subscribe((user) => {
      if (user) {
        this.navbarToolbarContentService.setEmailAddress(user.email || '');        
      }
    });

    this.merchantService.merchant$.pipe(takeUntil(this.destroy$)).subscribe(merchant =>
    {
      if (merchant)
      {
        console.log('Merchant data:', merchant);
        this.navbarToolbarContentService.displaySignatureMessage$.next(merchant?.merchantStatus === MerchantStatusEnum.ENROLLMENT_WITHOUT_SIGNATURE);
      }
    });
  }
  openSignatureDialog(): void {
    this.dialog.open(EnrollmentSignatureDialogComponent, {
      width: '550px',
      disableClose: true
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loginWithRedirect(): void {
    this.authService.loginWithRedirect();
  }

  logout(): void {
    this.authService.logout({ returnTo: window.location.origin });
  }
}
